import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <div>
      <div className="collapse navbar-collapse justify-content-center" id="bs-example-navbar-collapse-1">
        <ul className="navbar-nav align-items-center" id="responsive-menu">

          <li className="nav-item">
            <Link to="/" className="nav-link px-2 my-4 py-0 text-black">Home</Link>
          </li>
           <li><Link to="/agenda" className="nav-link px-2 my-4 py-0 text-black">AGENDA</Link></li>

      

          {/* Dropdown example: use button for toggler */}
        <li className="nav-item dropdown">
  <span
    className="nav-link dropdown-toggle px-2 my-4 py-0 text-black text-uppercase"
    id="speakerDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Speaker
  </span>
  <ul className="dropdown-menu bg-lightgrey p-0 rounded" aria-labelledby="speakerDropdown">
    <li>
      <Link className="dropdown-item py-3 px-6 black border-0 text-uppercase" to="/becomespeaker">
        Become Speaker
      </Link>
    </li>
    <li>
      <Link className="dropdown-item py-3 px-6 black border-0 text-uppercase" to="/speakerbenefits">
        Benefits of Speaker
      </Link>
    </li>
  </ul>
</li>


          {/* Repeat the same pattern for other dropdowns */}

<li className="nav-item dropdown">
  <span
    className="nav-link dropdown-toggle px-2 my-4 py-0 text-black text-uppercase"
    id="scheduleDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    Sponsor & Exhibit
  </span>
  <ul className="dropdown-menu bg-lightgrey p-0 rounded" aria-labelledby="scheduleDropdown">
    <li>
      <Link className="dropdown-item py-3 px-6 black border-0 text-uppercase" to="/sponsors">
        Sponsorship & Benefits
      </Link>
    </li>
  </ul>
</li>



          <li className="nav-item">
            <Link to="/contact" className="nav-link px-2 my-4 py-0 text-black">Contact</Link>
          </li>


        </ul>
      </div>
    </div>
  );
};

export default Navbar;
